<div class="actual-vs-projections-table-title">
    <h3 class="title">Loan Officers - Actuals Vs. Projections</h3>
</div>

<div class="row-layout-track actual-vs-projections-table">
    <kendo-grid
        #grid="kendoGrid"
        class="lg-kendo-grid actual-vs-projections-kendo"
        [data]="gridView"
        [skip]="skip"
        [loading]="loading"
        [sortable]="sortable"
        [sort]="sort"
        [scrollable]="scrollable"
        [pageable]="pageable"
        [pageSize]="pageSize"
        (pageChange)="pageChange($event)"
        (sortChange)="sortChange($event)"
    >
        <ng-template kendoGridNoRecordsTemplate>
            <div class="no-data-message-area" *ngIf="!loading && noDataForCompany">
                <no-data-screen [noDataType]="noDataType"></no-data-screen>
            </div>
        </ng-template>
        <kendo-grid-column
            field="lo"
            title="Loan Officer"
            [headerClass]="'reports-header'"
            [width]="50"
        >
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.lo }}
            </ng-template>
            <ng-template kendoGridFooterTemplate> Total </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="actualVolume"
            title="Actuals Volume"
            [headerClass]="'reports-header'"
            [width]="60"
        >
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.actualVolume | currency: 'USD':'symbol':'1.0-0' }}
            </ng-template>
            <ng-template kendoGridFooterTemplate>
                {{ sumActualVolume | currency: 'USD':'symbol':'1.0-0' }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="projectionsVolume"
            title="Projections Volume"
            [headerClass]="'reports-header'"
            [width]="60"
        >
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.projectionVolume | currency: 'USD':'symbol':'1.0-0' }}
            </ng-template>
            <ng-template kendoGridFooterTemplate>
                {{ sumProjectionVolume | currency: 'USD':'symbol':'1.0-0' }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="actualUnit"
            title="Actuals Units"
            [headerClass]="'reports-header'"
            [width]="50"
        >
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.actualUnits }}
            </ng-template>
            <ng-template kendoGridFooterTemplate>
                {{ sumActualUnits }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="projectionsUnit"
            title="Projections Units"
            [headerClass]="'reports-header'"
            [width]="50"
        >
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.projectionUnits }}
            </ng-template>
            <ng-template kendoGridFooterTemplate>
                {{ sumProjectionUnits }}
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="volumePctRatio"
            title="Actuals vs Projections Completion - Volume"
            [headerClass]="'reports-header'"
            [width]="120"
        >
            <ng-template kendoGridCellTemplate let-dataItem>
                <column-bar-graph
                    [value]="dataItem.volumePctRatio"
                    [percent]="dataItem.volumePctRatio"
                    [format]="'percent'"
                >
                </column-bar-graph>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>
